export const media = {
  types: {
    pdf: "PDF Document",
    audio: "Audio File",
    video: "Video",
    image: "Image",
    ebook: "E-Book",
    document: "Document",
    archive: "Archive",
    package: "Package",
    unknown: "Unknown File",
  },
  actions: {
    download: "Download",
    downloading: "Downloading...",
    view: "View",
    play: "Play",
    open: "Open",
  },
  fileSize: {
    kb: "KB",
    mb: "MB",
    gb: "GB",
  },
  labels: {
    filename: "Filename",
    fileType: "Type",
    fileSize: "Size",
    contentMaterials: "Content Materials",
    file: "file",
    files: "files",
  },
  messages: {
    accessAfterPurchase: "You'll have access to all files after purchase.",
  },
};
